import { CustomerProvider } from "@/contexts/CustomerContext";
import { CustomerLayout } from "@/components/customer/CustomerLayout";

const CustomerDashboard = () => {
  return (
    <CustomerProvider>
      <CustomerLayout />
    </CustomerProvider>
  );
};

export default CustomerDashboard;
